import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-code-icon',
  templateUrl: './code-code.component.html'
})
export class CodeCodeComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
